module.exports = __webpack_public_path__ + "img/user1.f87c46f3.png";